import { useNavigate } from "react-router-dom";
import styles from './index.module.scss'

export const Description = () =>{
  const navidate = useNavigate();
  return <div className={styles.description}>
    <div className={styles.title}>交易须知:</div>
    <div className={styles.content}>
      <p>1、使用欧易、币安或芝麻开门等交易所购买USDT（<span className={styles.goto} onClick={() => navidate('/helps?index=7')}>交易所交易教程</span>）</p>
      <p>2、选择币种（USDT或者TRX）</p>
      <p>3、输入转入数量，最小转入数量300V币，若转账金额小于以上金额系统将会自动取消该笔交易，给您造成不必要的损失</p>
      <p>4、复制转入地址，使用区块链钱包转账至该地址对应数量USDT/TRX</p>
      <p>5、点击确认转入，输入资金密码，订单创建完成（请实时留意订单状态，可在”订单“-”区块链订单“菜单查询订单状态，请十五分钟内完成转账）</p>
      <p>6、转账USDT/TRX之后系统自动判断，自动到账V币，到账金额根据实际转账金额计算.</p>
    </div>
  </div>
}